module.exports = __webpack_public_path__ + "Qlik-Logo_RGB.png";